import React, { useState } from 'react';
import { Container, Typography, Box, ImageList, ImageListItem, Button, Tabs, Tab } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CollectionsIcon from '@mui/icons-material/Collections';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import ResponsiveTitle from '../components/ResponsiveTitle';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`gallery-tabpanel-${index}`}
      aria-labelledby={`gallery-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const eventImages = [
  {
    src: '/images/gallery/23 06 01 - René Cassin.jpg',
    title: 'LAN à René Cassin - Juin 2023',
  },
  {
    src: '/images/gallery/rezo.JPG',
    title: 'Installation du réseau',
  },
  {
    src: '/images/gallery/DSCN1672.JPG',
    title: 'En pleine action !',
  },
  {
    src: '/images/gallery/equipe yabouca.JPG',
    title: 'L\'équipe Yabouca',
  },
  {
    src: '/images/gallery/pc a wolverine.JPG',
    title: 'Setup de Wolverine',
  },
  // Ajout d'autres photos d'événements
];

const gameImages = [
  {
    src: '/images/images jeux/Call-of-Duty-2.jpg',
    title: 'Call of Duty 2 - Un classique des LAN',
  },
  {
    src: '/images/images jeux/War3-TD.jpg',
    title: 'Warcraft III - Tower Defense',
  },
  {
    src: '/images/images jeux/left-4-dead-2.jpg',
    title: 'Left 4 Dead 2 - Survie en équipe',
  },
  {
    src: '/images/images jeux/split-second.jpg',
    title: 'Split Second - Course explosive',
  },
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentImages, setCurrentImages] = useState(eventImages);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
    setCurrentImages(newValue === 0 ? eventImages : gameImages);
    setPhotoIndex(0);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          bgcolor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: 4,
          px: 3,
          py: 1,
          color: 'white',
          width: 'fit-content',
          mb: 4,
          mx: 'auto'
        }}>
          <CollectionsIcon />
          <ResponsiveTitle variant="h4">
            Galerie Photos
          </ResponsiveTitle>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            centered
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Photos des Événements" />
            <Tab label="Notre Collection de Jeux" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            Revivez nos meilleurs moments en LAN !
          </Typography>
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            Découvrez les jeux auxquels nous jouons régulièrement !
          </Typography>
        </TabPanel>

        <ImageList
          sx={{
            width: '100%',
            height: 'auto',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)!important',
              sm: 'repeat(2, 1fr)!important',
              md: 'repeat(3, 1fr)!important',
            },
          }}
          gap={16}
        >
          {currentImages.map((img, index) => (
            <ImageListItem
              key={img.src}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                  transform: 'scale(1.02)',
                  transition: 'all 0.2s ease-in-out'
                }
              }}
            >
              <img
                src={img.src}
                alt={img.title}
                loading="lazy"
                style={{
                  borderRadius: '8px',
                  width: '100%',
                  height: 300,
                  objectFit: 'cover'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  bgcolor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  padding: 1,
                  borderBottomLeftRadius: '8px',
                  borderBottomRightRadius: '8px',
                }}
              >
                <Typography variant="subtitle1">
                  {img.title}
                </Typography>
              </Box>
            </ImageListItem>
          ))}
        </ImageList>

        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={currentImages}
        />
      </Box>
    </Container>
  );
};

export default Gallery;
